export function resizeCanvasToDisplaySize(canvas: HTMLCanvasElement, multiplier = 1) {
	const width = (canvas.clientWidth * multiplier) | 0
	const height = (canvas.clientHeight * multiplier) | 0

	if (canvas.width !== width || canvas.height !== height) {
		canvas.width = width
		canvas.height = height
		return true
	}

	return false
}

function isOffscreenCanvas(canvas: HTMLCanvasElement | OffscreenCanvas): canvas is OffscreenCanvas {
	return "OffscreenCanvas" in window && canvas instanceof OffscreenCanvas
}

export function getCanvasSize(canvas: HTMLCanvasElement | OffscreenCanvas): [number, number] {
	return isOffscreenCanvas(canvas)
		? [canvas.width, canvas.height]
		: [canvas.clientWidth, canvas.clientHeight]
}
